//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//

(function () {

    'use strict';

    angular.module('container.components')
        .directive('srsngLanguages', srsngLanguages);

    function srsngLanguages($rootScope, Localization) {

        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/components/languages/languages.html',
            scope: {
                visible: '='
            },
            controller: controller
        };

        function controller($scope) {

            $rootScope.$on('localizationService:supportedLanguagesChanged', updateLanguages);

            function updateLanguages() {

                $scope.languages = Localization.languages;
            }

            updateLanguages();

            $scope.selectLanguage = function(language) {

                console.log('Language selected ' + language.displayName);

                var cookies = document.cookie;
                console.log("cookies: " + cookies);

                Localization.changeLanguage(language);
                $scope.visible = false;
            }
        }

    }

})();

